const apiUrl = {
  ds: "ds_api",
};

export function getProxyUrl(url) {
  return `/proxy/${apiUrl.ds}${url}`;
}

// Writes block the UI by default (see api.js). Fire-and-forget calls nobody
// is waiting on -- long polls, "seen" markers, last-committee bookkeeping --
// opt out with this so they never raise the blocking overlay.
export const BACKGROUND = { background: true };

export function getQueryParams(params) {
  const parts = [];
  for (const name of Object.keys(params)) {
    const value = params[name];
    if (value === null) continue;
    if (Array.isArray(value)) {
      value.forEach((val) => {
        if (val !== null) parts.push(`${name}=${val}`);
      });
    } else {
      parts.push(`${name}=${value}`);
    }
  }
  return parts.length ? `?${parts.join("&")}` : "";
}

export function addQueryParams(url, params) {
  if (!params) {
    return url;
  }

  return `${url}${getQueryParams(params)}`;
}

export function addQueryParamsEncoded(url, params) {
  if (!params || typeof params !== "object") return url;

  const queryString = Object.keys(params)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`,
    )
    .join("&");

  return queryString ? `${url}?${queryString}` : url;
}

export const addPageQueryParam = (query, page) => {
  if (query.pageLength) {
    query.start = query.pageLength * page + 1;
  } else {
    console.error("pageLength missing in query, page attribute not set");
  }
  return query;
};

export function isRequestSuccessful(response) {
  return response && response.status >= 200 && response.status <= 299;
}

export const TIMEFRAME = {
  PAST: "past",
  FUTURE: "future",
  ALL: "all",
};
